/* eslint-disable import/prefer-default-export */
import { useEffect } from "react"

import {
  getPortalStatistics,
  selectPortalStatistics,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"

export const useStatistics = () => {
  const statistics = useDappSelector(selectPortalStatistics)
  const dispatch = useDappDispatch()

  useEffect(() => {
    const fetchStatistics = async () => {
      if (statistics) return

      await dispatch(getPortalStatistics())
    }

    fetchStatistics()
  }, [statistics, dispatch])
}
